
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "es",
  "fr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_4bd4b6a8",
      load: () => import("#nuxt-i18n/4bd4b6a8" /* webpackChunkName: "locale_en_46json_4bd4b6a8" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_15295bda",
      load: () => import("#nuxt-i18n/15295bda" /* webpackChunkName: "locale_de_46json_15295bda" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_007f7718",
      load: () => import("#nuxt-i18n/007f7718" /* webpackChunkName: "locale_es_46json_007f7718" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_512fcb40",
      load: () => import("#nuxt-i18n/512fcb40" /* webpackChunkName: "locale_fr_46json_512fcb40" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de-DE",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      dir: "ltr",
      files: [
        {
          path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/fr.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "src/shared/locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_language",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de-DE",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    dir: "ltr",
    files: [
      {
        path: "/codebuild/output/src770833638/src/actions-runner/builds/O_g_uFoR3/0/litimiliwili/fe-monorepo/apps/mili/src/shared/locales/fr.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/